<template>
  <b-container fluid class="mt-50">
    <b-container fluid>
      <b-row class="bg-white py-4 my-3">
        <b-col cols="12" md="8" class="d-flex align-items-center">
          <h5 class="f-default">Detalhes do Plano de Ação</h5>
        </b-col>
        <b-col cols="6" md="2">
          <b-button variant="success" class="w-100"> Salvar </b-button>
        </b-col>
        <b-col cols="6" md="2">
          <b-button variant="primary" class="w-100"> Automatizado </b-button>
        </b-col>
      </b-row>

      <b-row class="bg-white py-4 my-3">
        <b-col md="6" xl="8" cols="6">
          <b-form-group label="Ativos" class="f-default">
            <!-- <multiselect
              v-model="object.value"
              tag-placeholder="Add this as new tag"
              placeholder="Selecione ou add"
              label="name"
              track-by="code"
              :options="options"
              :multiple="true"
              :taggable="true"
              :select-label="'Clique para adicionar'"
              :deselectLabel="'Clique para remover'"
              :selectedLabel="'Selecionado'"
            /> -->
          </b-form-group>
        </b-col>
        <app-count
          :countNum="50"
          :countText="'Ativos'"
          :classSpan="'text-blue'"
        />
        <app-count
          :countNum="50"
          :countText="'Sistemas Operacionais'"
          :classSpan="'text-green'"
          :classDiv="'col-xl-2'"
        />
        <app-count
          :countNum="50"
          :countText="'Redes'"
          :classSpan="'text-orange'"
        />
      </b-row>

      <b-row class="bg-white py-4 my-3 px-2">
        <b-col cols="12" xl="4">
          <h4 class="text-purple w-100 f-default">Filtros</h4>

          <b-row>
            <b-col
              :cols="card.cols"
              :md="card.md"
              v-for="(card, index) in filterCards"
              :key="index"
              class="py-2"
            >
              <h5 class="f-default">{{ card.title }}</h5>
              <toggle-button
                v-b-tooltip.hover
                :title="card.toltipText"
                :value="object.priority"
                :color="{
                  checked: '#ffbf36',
                  unchecked: '#f83f37',
                  disabled: '#6f7a7f',
                }"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="6" xl="4">
          <b-row>
            <b-col cols="12">
              <span class="display-3 text-red counter-anim f-default">50</span>
              <small class="d-block f-default">Total de Vulnerabilidades</small>
            </b-col>
            <b-col cols="12">
              <app-progress
                :data="data"
                v-for="(data, index) in progressArray"
                :key="index"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="6" xl="4">
          <h4 class="text-orange w-100 f-default">Controles</h4>
          <b-row class="my-2">
            <b-col cols="12" md="6">
              <h6 class="f-default">Severidade</h6>
            </b-col>
            <b-col cols="12" md="6">
              <vue-slider v-model="value" :min="0" :max="10" />
            </b-col>
          </b-row>
          <b-row class="my-2">
            <b-col cols="12" md="6">
              <h6 class="f-default">Alta Prioridade</h6>
            </b-col>
            <b-col cols="12" md="6" class="d-flex align-items-center">
              <toggle-button
                :value="object.priority"
                :color="{
                  checked: '#ffbf36',
                  unchecked: '#f83f37',
                  disabled: '#6f7a7f',
                }"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
              />
            </b-col>
          </b-row>
          <b-row class="my-2">
            <b-col cols="12" md="6">
              <h6 class="f-default">Facilmente Exploravel</h6>
            </b-col>
            <b-col cols="12" md="6" class="d-flex align-items-center">
              <toggle-button
                :value="object.explority"
                :color="{
                  checked: '#ffbf36',
                  unchecked: '#f83f37',
                  disabled: '#6f7a7f',
                }"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6" class="d-flex align-items-center">
              <h6 class="f-default">Possui Automação?</h6>
            </b-col>
            <b-col cols="12" md="6">
              <b-button-group>
                <b-button variant="outline-secondary">Sim</b-button>
                <b-button variant="outline-secondary">Não</b-button>
                <b-button variant="outline-secondary">Todos</b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row class="bg-white py-4 my-3">
        <b-col cols="12" md="12" xl="4" class="">
          <b-row class="d-flex align-items-center">
            <b-col cols="12" md="6" xl="4" class="">
              <h5 class="f-default text-center">Ativos priozirados</h5>
            </b-col>
            <b-col cols="12" md="6" xl="4">
              <graphPieChart id="chart"/>
            </b-col>
            <b-col cols="12" md="12" xl="4" class="text-center ">
              <h3 class="f-default f-bold mb-0">1747</h3>
              <small> de 8979 ativos </small>
            </b-col>
          </b-row>
        </b-col>
         <b-col cols="12" md="12" xl="4" class="">
          <b-row class="d-flex align-items-center">
            <b-col cols="12" md="6" xl="4" class="">
              <h5 class="f-default text-center">Vulnerabilidade</h5>
            </b-col>
            <b-col cols="12" md="6" xl="4">
              <graphPieChart  id="chart2" />
            </b-col>
            <b-col cols="12" md="12" xl="4" class="text-center ">
              <h3 class="f-default f-bold mb-0">1747</h3>
              <small> de 8979 vulnerabilidades </small>
            </b-col>
          </b-row>
        </b-col>
         <b-col cols="12" md="12" xl="4" class="">
          <b-row class="d-flex align-items-center">
            <b-col cols="12" md="6" xl="4" class="">
              <h5 class="f-default text-center">Ações</h5>
            </b-col>
            <b-col cols="12" md="6" xl="4">
              <graphPieChart   id="chart3"/>
            </b-col>
            <b-col cols="12" md="12" xl="4" class="text-center ">
                           <graphPieChart   id="chart4"/>

            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row class="bg-white py-4 my-3">
        <b-col cols="12">
          <app-table
            :data-array="items"
            :fields="fields"
            title="Vulnerabilidades"
          />
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
import appCount from "@/components/_counterInfo";
import { mixins } from "@/mixins/mixins";
import appProgress from "@/components/vulnerability/_progress";
import graphPieChart from "@/components/graphs/_pieChart"
export default {
  components: {
    appCount,
    appProgress,
    graphPieChart
  },

  mixins: [mixins],
  data() {
    return {
      filterCards: [
        {
          title: "Malware",
          toltipText: "958 malwares",
          cols: 12,
          md: 6,
        },
        {
          title: "Public Exploit",
          toltipText: "958 public exploit",
          cols: 12,
          md: 6,
        },
        {
          title: "DDOS",
          toltipText: "958 ddos",
          cols: 12,
          md: 6,
        },
        {
          title: "Patches",
          toltipText: "958 patches",
          cols: 12,
          md: 6,
        },
      ],
      progressArray: [
        {
          id: 1,
          title: "Criticidade Baixa",
          color: "#27c42f",
          progress: 80,
          number: 234,
        },
        {
          id: 2,
          title: "Criticidade Média",
          color: "#fcbe03",
          progress: 30,
          number: 123,
        },
        {
          id: 3,
          title: "Criticidade Alta",
          color: "#fc7b03",
          progress: 50,
          number: 198,
        },
        {
          id: 4,
          title: "Criticidade Crítica",
          color: "#d62020",
          progress: 100,
          number: 356,
        },
      ],
      fields: [
        { key: "name", label: "Nome da Vulnerabilidade" },
        { key: "CVE", label: "CVE" },
        { key: "sev", label: "Severidade" },
        { key: "qnt", label: "Quantidade Ativos" },
        { key: "trat", label: "Tratamento" },
        { key: "actions", label: "Seleção" },
      ],
      items: [
        {
          id: 1,
          name: "Ativo teste2",
          CVE: "408",
          sev: "Baixa",
          sev_qnt: 1,
          qnt: 1745,
          trat: "Não",
          sev_status: "success",
        },
        {
          id: 2,
          name: "Ativo teste2",
          CVE: "408",
          sev: "Alta",
          sev_qnt: 175,
          qnt: 1745,
          trat: "Sim",
          sev_status: "danger",
        },
      ],
      object: {},
      value: [0, 10],
      options: [
        { name: "Vue.js", code: "vu" },
        { name: "Javascript", code: "js" },
        { name: "Open Source", code: "os" },
      ],
    };
  },

  methods: {},
};
</script>

<style lang="scss">
.form-group {
  .fa-list {
    position: absolute;
    left: 16px;
    top: 4px;
  }
}
</style>
